var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeakerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1262_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6152 4.00195L14.1875 5.38887C15.1417 6.40571 15.7113 7.60938 15.7113 8.9999C15.7113 10.3904 15.138 11.6839 14.1875 12.6109L15.6189 14.0015C17.0503 12.7044 17.716 10.8539 17.8122 8.9999C17.8085 7.14947 17.1427 5.29905 15.6152 4.00195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9996 8.99938H19.9024C19.9024 6.68545 18.9481 4.55476 17.3281 2.88758L18.7595 1.49707C20.8567 3.4445 21.9996 6.13211 21.9996 8.99938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7595 16.5023L17.3281 15.1118C19.0443 13.4446 19.9024 11.3139 19.9024 9H21.9995C21.9995 11.8708 20.8566 14.5584 18.7595 16.5023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.963 18C10.6782 18 10.4895 17.9066 10.3009 17.7233L4.72695 13.135H1.03934C0.473435 13.135 0 12.6751 0 12.1253V5.8806C0 5.33086 0.473435 4.87095 1.03934 4.87095H4.72695L10.3009 0.279019C10.5857 0.00235355 11.0555 -0.0874727 11.3403 0.0957734C11.7175 0.27902 11.9062 0.645512 11.9062 1.0156V16.9903C11.9062 17.3568 11.7175 17.7233 11.3403 17.9102C11.2478 18 11.0591 18 10.963 18ZM2.07868 11.1157H5.10422C5.38902 11.1157 5.57766 11.2091 5.76629 11.3924L9.92364 14.7878V3.21814L5.76629 6.61718C5.57766 6.80043 5.38902 6.89385 5.10422 6.89385H2.07868V11.1157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.03906,
    y: 1,
    width: 23.9178,
    height: 1.7,
    transform: "rotate(37.5328 3.03906 1)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1262_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerIcon);
export default __webpack_public_path__ + "static/media/SpeakerIcon.72d4a5e44e1c0b911f94a6157f2edf72.svg";
export { ForwardRef as ReactComponent };